import { QueryParamsEntities } from "./MainApp";
import { Pagination } from "./Pagination";

export class DepositAmount {
  status = "";
  collectedPieces = 0;
  collected = 0;
  pending = 0;
  pendingPieces = 0;

  constructor(fields?: Partial<DepositAmount>) {
    Object.assign(this, fields);
  }
}

export class SttInDelivery {
  status = "";
  count = 0;
  pieces = 0;

  constructor(fields?: Partial<SttInDelivery>) {
    Object.assign(this, fields);
  }
}

export class CourierSummary {
  codAmountDeposit = new DepositAmount();
  sttDeposit: DepositAmount[] = [];
  sttInDelivery: SttInDelivery[] = [];

  constructor(fields?: Partial<CourierSummary>) {
    Object.assign(this, fields);
  }
}

export class CourierDetail {
  sttCodAmount = 0;
  sttCollectionStatus = "";
  sttRecipientName = "";
  sttRecipientPhone = "";
  sttNo = "";
  sttStatus = "";
  sttReason = "";
  sttPaymentMethod = "";
  sttDeliveryDate = "";
  sttCodType = "";

  constructor(fields?: Partial<CourierDetail>) {
    Object.assign(this, fields);
  }
}

export class DetailSetorRiwayat {
  updatedAt = "";
  updatedByName = "";
  totalAmount = 0;
  totalPackage = 0;
  totalPiece = 0;
  photos: PhotosDetailSetorRiwayat[] = [];
  note = "";
  stt: SttDetailSetorRiwayat[] = [];

  constructor(fields?: Partial<DetailSetorRiwayat>) {
    Object.assign(this, fields);
  }
}

export class CourierDetailList {
  data: CourierDetail[] = [];

  constructor(fields?: Partial<CourierDetailList>) {
    Object.assign(this, fields);
  }
}

export class CodDashboardDetailCourier {
  courierPhone = "";
  courierName = "";
  courierId = 0;
  courierPartnerName = "";
  courierPartnerPhone = "";
  courierPartnerContactPhone = "";
  totalStt = 0;
  totalSttPod = 0;
  totalCollected = 0;
  totalQrisCollected = 0;
  totalOutstanding = 0;
  totalSttDexCollected = 0;
  totalSttDexOutstanding = 0;
  totalSttCodrejCollected = 0;
  totalSttCodrejOutstanding = 0;
  totalSttDel = 0;
  performanceSameDay = "";
  percentageSameDay = "";
  performanceDifferentDay = "";
  percentageDifferentDay = "";
  constructor(fields?: Partial<CodDashboardDetailCourier>) {
    Object.assign(this, fields);
  }
}

export class BankDetail {
  bankId = "";
  bankName = "";
  bankAccount = "";
  bankAccountName = "";
  constructor(fields?: Partial<BankDetail>) {
    Object.assign(this, fields);
  }
}

export class DashboardDeliveryCourierDetail {
  id = 0;
  courierId = 0;
  fullname = "";
  phoneNumber = "";
  partnerType = "";
  partnerName = "";
  announcementCourierType = "";
  courierType = "";
  vehicleType = "";
  vehiclePlate = "";
  courierStatus = "";
  courierIsCod = false;
  bank = new BankDetail();
  constructor(fields?: Partial<DashboardDeliveryCourierDetail>) {
    Object.assign(this, fields);
  }
}

export class CourierDetailApiRequest {
  type = "";
  driverPhone = "";
  filterDate = "";
  status = "";
  picPhone = "";
  isAllType = true;
  hubId = 0;

  constructor(fields?: Partial<CourierDetailApiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class SettlementListRequest {
  courierId = 0;
  reconcileStatus = "";
  reconcileFor = "";
  date = "";

  constructor(fields?: Partial<SettlementListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class SttSettlementData {
  sttNo = "";
  totalAmount = 0;
  codType = "";
  lastStatus = "";
  totalPiece = 0;
  isReconciled = false;

  constructor(fields?: Partial<SttSettlementData>) {
    Object.assign(this, fields);
  }
}

export class SettlementListData {
  settlementId = 0;
  courierId = 0;
  personName = "";
  location = "";
  paymentMethod = "";
  totalAmount = 0;
  totalPackage = 0;
  totalPiece = 0;
  proofUrls = [];
  createdAt = "";
  stt: SttSettlementData[] = [];

  constructor(fields?: Partial<SettlementListData>) {
    Object.assign(this, fields);
  }
}

export class SettlementListResponse {
  pagination = new Pagination(1, 10);
  data: SettlementListData[] = [];

  constructor(fields?: Partial<SettlementListResponse>) {
    Object.assign(this, fields);
  }
}

export class CourierDetailPendingReconcile {
  dateGroup = "";
  codAmount = 0;
  sttAmount = 0;
  sttPieces = 0;

  constructor(fields?: Partial<CourierDetailPendingReconcile>) {
    Object.assign(this, fields);
  }
}

export class CourierNotesPhoto {
  uploadedAt = "";
  uploadedBy = 0; // account id
  uploadedByType = ""; // account partner type
  url = "";
  constructor(fields?: Partial<CourierNotesPhoto>) {
    Object.assign(this, fields);
  }
}

export class CourierSttHistory {
  sttNo = "";
  amount = 0;
  lastStatus = "";
  totalPiece = 0;
  codType = "";
  isReconciled = false;
  settlementId = 0;

  constructor(fields?: Partial<CourierSttHistory>) {
    Object.assign(this, fields);
  }
}

export class CourierNotes {
  id = 0;
  date = "";
  note = "";
  photos: CourierNotesPhoto[] = [];

  constructor(fields?: Partial<CourierNotes>) {
    Object.assign(this, fields);
  }
}

export class CourierHistory {
  id = 0;
  date = "";
  note = "";
  createdAt = "";
  updatedAt = "";
  amount = 0;
  photos: CourierNotesPhoto[] = [];
  stt: CourierSttHistory[] = [];
  totalPiece = 0;
  updatedByName = "";
  paymentMethod = "";
  recipientLocation = "";
  recipientName = "";
  settlementId = 0;
  constructor(fields?: Partial<CourierHistory>) {
    Object.assign(this, fields);
  }
}

export class SttDetailSetorRiwayat {
  sttNo = "";
  lastStatus = "";
  codType = "";
  totalAmount = 0;
  totalPiece = 0;
  isReconciled = false;

  constructor(fields?: Partial<SttDetailSetorRiwayat>) {
    Object.assign(this, fields);
  }
}

export class PhotosDetailSetorRiwayat {
  url = "";

  constructor(fields?: Partial<PhotosDetailSetorRiwayat>) {
    Object.assign(this, fields);
  }
}

export class DetailDepositRiwayat {
  updatedAt = "";
  createdAt = "";
  updatedByName = "";
  totalAmount = 0;
  totalPackage = 0;
  totalPiece = 0;
  totalStt = 0;
  recipientName = "";
  recipientLocation = "";
  paymentMethod = "";
  photos: PhotosDetailSetorRiwayat[] = [];
  stt: SttDetailSetorRiwayat[] = [];

  constructor(fields?: Partial<DetailDepositRiwayat>) {
    Object.assign(this, fields);
  }
}

export class TaskSetllementCourier {
  settlementId = 0;
  courierId = 0;
  personName = "";
  location = "";
  paymentMethod = "";
  totalAmount = 0;
  totalPackage = 0;
  totalPiece = 0;
  proofUrls: string[] = [];
  createdAt = "";
  stt: SttDetailSetorRiwayat[] = [];
  constructor(fields?: Partial<TaskSetllementCourier>) {
    Object.assign(this, fields);

    if (fields?.stt?.length) {
      this.stt = fields.stt.map((stt: any) => new SttDetailSetorRiwayat(stt));
    }
  }
}
